export default __webpack_public_path__ + "static/media/screen5.5c90e888.jpg";